import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { _axios } from "../../plugins/axios";
import { URL, USER } from "../../constants/constant";
import Button from "react-bootstrap/Button";
import { decrptor, maskingAdhaar, maskPassportVID } from "../common/regex";
import auth from "../../auth/auth";
import { Form } from "react-bootstrap";
import { UserLoginDialog } from "../newUpsell/userLoginDialog";
import CarouselContainer from "../posters/carousel";
import { Backdrop, CircularProgress } from "@mui/material";

class DependantOrderDashboard extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {
      userdata: USER.user,
      orderStatus: null,
      activeTab: this.props.match.params.orderStatus ? this.props.match.params.orderStatus : "pending",
      pendingCaseCount: null,
      completedCaseCount: null,
      ordersList: null,
      orderStatusId: this.props.match.params.orderStatus
        ? this.props.match.params.orderStatus == "pending"
          ? "pending"
          : "sample collected"
        : "pending",
      todayTomorrowMsg: null,
      todaySubMsg: null,
      createOrderRedirectURL: "",
      selectedSample: null,
      messageSnack: "",
      showSnack: false,
      orderId: null,
      searchedOrders: null,
      searched: false,
      isAnyOrderInSampleTakenState: false,
      openOrderCreationPopup: false,
      upSellUserName:"",
      dataLoadingCompletion: false,
      isLoading: false,
    };
  }
  handleDataLoaded = () => {
    this.setState({ dataLoadingCompletion: true });
  };

  componentWillReceiveProps(nextProps) {
    console.log("nextProps", nextProps);
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.match.params.orderStatus !== this.state.activeTab) {
      this.setState({
        activeTab: nextProps.match.params.orderStatus ? nextProps.match.params.orderStatus : "pending",
        orderStatusId: nextProps.match.params.orderStatus == "pending" ? "pending" : "sample collected",
      });
    }
  }
  removeLocalStorage() {
    localStorage.removeItem("customer_phoneNumber");
    localStorage.removeItem("upsellMemberDetailsConfirm");
    localStorage.removeItem("orderTestDetails");
    localStorage.removeItem("upsellOrderIds");
    localStorage.removeItem("order_details");
    localStorage.removeItem("lab_technician_number");
    localStorage.removeItem("phlebo_start_order_trip_details");
    localStorage.removeItem("AppointmentDate");
    localStorage.removeItem("AppointmentId");
    localStorage.removeItem("City");
    localStorage.removeItem("DID");
    localStorage.removeItem("userName");
    localStorage.removeItem("selectedBenef");
    localStorage.removeItem("cart");
    localStorage.removeItem("user_short_token")
    localStorage.removeItem("parentOrderDetails")
    USER.orderDetails = null;
  }

  componentDidMount() {
    if (!localStorage.getItem("access_token")) {
      if (this.props.match.params.token != undefined) {
        let that = this;
        let url = URL.dev_url;
        let route = url + "verifyotp";

        let body = {
          isCheckToken: true,
          token: this.props.match.params.token,
        };
        _axios
          .post(route, body)
          .then(function (response) {
            console.log(response);
            if (response.data.success || response.data.isSuccess) {
              if (response.data.message) {
                that.showAlert(`${response.data.message}`, 2500);
                auth.login(() => {
                  // that.removeLocalStorage();
                  localStorage.setItem("access_token", that.props.match.params.token);
                  localStorage.setItem("user_details", JSON.stringify(response.data.userdetails));
                  localStorage.setItem("isAndroidLogin", true);
                  USER.user = response.data.userdetails;
                  /// -------------------------------
                  that.props.history.push("/dependantOrders");
                });
              } else if (!response.data.message) {
                this.showAlert("Invalid Tokken Passed!", 2500);
              }
            }
          })
          .catch(function (error) {
            that.showAlert(`${error}`, 2500);
            console.log(error);
          });
      } else {
        console.log("this is working");
        // this.props.history.push('./login')
      }
    } else {
      this.removeLocalStorage();
      (USER.user = localStorage.getItem("user_details") ? JSON.parse(localStorage.getItem("user_details")) : null),
      this.getOrders();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedSample != this.state.selectedSample) {
      console.log("Update the page!!");
      this.getOrders();
    }
  }

  getPendingCompletedCases() {
    let pendingCase = this.state.groupedPendingAndSampleTakenOrders ? Object.keys(this.state.groupedPendingAndSampleTakenOrders).length : 0;
    let completedCase = this.state.completedOrders ? Object.keys(this.state.completedOrders).length : 0;

    this.setState({
      pendingCaseCount: pendingCase,
      completedCaseCount: completedCase,
    });
  }
  getOrders() {
    const that = this;
    let url = URL.dev_url;
    let route = url + "getorders";
    let obj = {
      phleboId: this.state.userdata ? this.state.userdata.phleboId : JSON.parse(localStorage.getItem("user_details")).phleboId,
    };

    _axios
      .post(route, obj)
      .then(function (response) {
        const isAnyOrderInSampleTakenState = response.data.sampleTakenOrders.length > 0 ? true : false;

        const pendingAndSampleTakenOrders = [...response.data.pendingOrders, ...response.data.sampleTakenOrders];
        let groupedPendingAndSampleTakenOrders = null;
        const completedOrders = response.data.completedOrders;
        let groupedCompletedOrders = null;

        if (pendingAndSampleTakenOrders.length) {
          groupedPendingAndSampleTakenOrders = {};
          let dependantIndex = {};
          pendingAndSampleTakenOrders.forEach((order, index) => {
            const dependantId = order.dependantId;
            if(!dependantIndex[dependantId]) {
              dependantIndex[dependantId] = index + 1;
            }
            if (!groupedPendingAndSampleTakenOrders[dependantIndex[dependantId]]) {
              groupedPendingAndSampleTakenOrders[dependantIndex[dependantId]] = [];
            }
            groupedPendingAndSampleTakenOrders[dependantIndex[dependantId]].push(order);
          });
        }
        if (completedOrders.length) {
          groupedCompletedOrders = {};
          completedOrders.forEach((order) => {
            const dependantId = order.dependantId;
            if (!groupedCompletedOrders[dependantId]) {
              groupedCompletedOrders[dependantId] = [];
            }
            groupedCompletedOrders[dependantId].push(order);
          });
        }
        that.setState(
          {
            groupedPendingAndSampleTakenOrders: groupedPendingAndSampleTakenOrders,
            pendingAndSampleTakenOrders: pendingAndSampleTakenOrders,
            completedOrders: groupedCompletedOrders,
            todayTomorrowMsg: response.data.todayTomorrowMsg,
            todaySubMsg: response.data.todaySubMsg,
            isAnyOrderInSampleTakenState: isAnyOrderInSampleTakenState
          },
          () => {
            that.getPendingCompletedCases();
          }
        );
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  renderRedirect = (orderstatus) => {
    let x = "/dependantOrders/" + orderstatus;
    this.props.history.push(x);
  };

  redirectToSample(elem, id) {
    if (elem.orderStatus.currentStatusId == 4 || elem.orderStatus.currentStatusId == 111) {
      let routerLink = "/dependantSample/collected/" + id;
      this.props.history.push(routerLink);
    } else if ([5, 51, 6, 7, 8, 9, 10, 11, 12].includes(elem.orderStatus.currentStatusId)) {
      let routerLink = "/dependantSample/collectedCompleted/" + id;
      this.props.history.push(routerLink);
    } else {
      let routerLink = "/dependantSample/" + id;
      this.props.history.push(routerLink);
    }
  }

  routeToLab(id) {
    let skip = false;
    if (skip) {
      //skipOtpState
      if (sampleData !== null) {
        sampleData = sampleData.filter((i) => i.orderStatus.currentStatusId === 6);

        if (sampleData.length === 0) {
          console.log("snackBar");

          setTimeout(() => {
            that.showAlert("Please complete mandatory OTP verification step to proceed to drop sample.", 2500);
          });
        } else {
          let routerLink = "/allLabs";
          this.props.history.push(routerLink);
        }
      } else {
        setTimeout(() => {
          that.showAlert("No orders available to be submitted!", 2500);
        });
      }
    } else {
      let routerLink = "/allLabs";
      this.props.history.push(routerLink);
    }
  }

  formatTodayTomorrow(date) {
    let currentDate = new Date();
    let tomorrowsDate = new Date();
    tomorrowsDate.setDate(tomorrowsDate.getDate() + 1);

    if (currentDate.getDate() == date.getDate()) {
      return "Today";
    } else if (tomorrowsDate.getDate() == date.getDate()) {
      return "Tomorrow";
    } else {
      return "";
    }
  }

  formatDate(date) {
    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    return date.getDate() + "-" + months[date.getMonth()] + "-" + date.getFullYear();
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    strTime = this.formatDate(date) + ", " + strTime;
    return strTime;
  }

  showAlert(message, timeout) {
    this.setState({
      messageSnack: message,
      showSnack: true,
    });
    setTimeout(() => {
      this.setState({
        messageSnack: "",
        showSnack: false,
      });
    }, timeout);
  }

  callbackForMembers = (result) => {
    this.showAlert(result.message, 2500);
    this.getOrders();
  };

  handleOrderId = (event) => {
    this.setState({
      orderId: event.target.value,
    });
  };

  fetchOrder = () => {
    let requiredOrders = this.state.pendingAndSampleTakenOrders.filter((order) => order.prOrderId == this.state.orderId);
    let groupedSearchedOrders = null;
    if (requiredOrders.length > 0) {
      groupedSearchedOrders = {};
      requiredOrders.forEach((order) => {
        const dependantId = order.dependantId;
        if (!groupedSearchedOrders[dependantId]) {
          groupedSearchedOrders[dependantId] = [];
        }
        groupedSearchedOrders[dependantId].push(order);
      });
    }
    this.setState({
      searchedOrders: groupedSearchedOrders,
      searched: true,
    });
  };


  upSellOrder=async (pendingOrder)=>{

    localStorage.removeItem("userName");
    localStorage.removeItem("selectedBenef");
    localStorage.removeItem("cart");
    localStorage.removeItem("user_short_token");
    localStorage.removeItem("parentOrderDetails");
    let parentOrderDetails ={
      ...pendingOrder.patientDetails[0],
      orderDateTime:pendingOrder.orderDateTime,
      orderId:pendingOrder.prOrderId
    }
    localStorage.setItem("parentOrderDetails", JSON.stringify(parentOrderDetails));
    localStorage.setItem("userName", pendingOrder.patientDetails[0].userName);
    this.setState( {openOrderCreationPopup: true,
    upSellUserName:pendingOrder.patientDetails[0].userName} );
  }

  getAge(birthDate) {
    return Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e+10);
  }

  showPendingCases() {
    return (
      <div>
        {this.state.groupedPendingAndSampleTakenOrders && (this.state.searched ? this.state.searchedOrders : true) ? (
          Object.keys(this.state.searched ? this.state.searchedOrders : this.state.groupedPendingAndSampleTakenOrders).map((elem, index) => {
            const pendingOrder = this.state.searched ? this.state.searchedOrders[elem][0] : this.state.groupedPendingAndSampleTakenOrders[elem][0];
            let requestIdsString = "";
            this.state.searched 
              ? this.state.searchedOrders[elem].forEach((order, index) => {
                  requestIdsString = requestIdsString + order.appointmentId;
                  if(index != this.state.searchedOrders[elem].length - 1) requestIdsString = requestIdsString + ", ";
                })
              : this.state.groupedPendingAndSampleTakenOrders[elem].forEach((order, index) => {
                  requestIdsString = requestIdsString + order.appointmentId;
                  if(index != this.state.groupedPendingAndSampleTakenOrders[elem].length - 1) requestIdsString = requestIdsString + ", ";
                });
            return (
              <div>
                <div
                  key={index}
                  className="card-box font-size-smd"
                  style={{ boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)" }}
                  onClick={(e) => this.redirectToSample(pendingOrder, pendingOrder.dependantId, e)}
                >
                  <div>
                    <b>
                      Order Status:{" "}
                      <span className={`font-color-${pendingOrder.orderStatus.currentStatusId}`}>{pendingOrder.orderStatus.statusMessage}</span>
                    </b>
                  </div>
                  <div className="p-t-10 width-100">
                    <b>Order ID:</b> {pendingOrder.prOrderId}
                  </div>
                  <div className="width-100">
                    <b>Dependant ID:</b> <span>{pendingOrder.dependantId ? pendingOrder.dependantId : "NA"}</span>
                  </div>
                  <div className="width-100 m-b-10">
                    <b>Request IDs:</b> {requestIdsString}
                  </div>
                  <div className="width-100 position-relative font-size-ml m-b-10">
                    <b>Patient: </b>

                    <span className=" m-r-5">
                      {pendingOrder.patientDetails[0].name +
                        " (Age: " +
                        (pendingOrder.patientDetails[0].patientAge != null ? pendingOrder.patientDetails[0].patientAge : this.getAge(pendingOrder.patientDetails[0].patientDOB)) +
                        ", Gender: " +
                        (pendingOrder.patientDetails[0].patientGender != null ? pendingOrder.patientDetails[0].patientGender : "NA") +
                        ")"}
                    </span>
                  </div>

                  <div>
                    {decrptor(pendingOrder.patientDetails[0].aadharNumber) && (
                      <div className="width-100">
                        <b>Aadhaar No:</b> {maskingAdhaar(decrptor(pendingOrder.patientDetails[0].aadharNumber))}
                      </div>
                    )}
                    {decrptor(pendingOrder.patientDetails[0].passPort) && (
                      <div className="width-100">
                        <b>Passport No / Voter ID:</b> {maskPassportVID(decrptor(pendingOrder.patientDetails[0].passPort))}
                      </div>
                    )}
                    {typeof pendingOrder.patientDetails[0].priority == "string" && pendingOrder.patientDetails[0].priority != "" ? (
                      <div className="width-100">
                        <b>Priority:</b> {pendingOrder.patientDetails[0].priority}
                      </div>
                    ) : (
                      ""
                    )}

                    {typeof pendingOrder.patientDetails[0].corporateName == "string" && pendingOrder.patientDetails[0].corporateName != "" ? (
                      <div className="width-100">
                        <b>Corporate:</b> {pendingOrder.patientDetails[0].corporateName}
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="width-100 display-flex">
                      <b>Appointment Time: </b> {this.formatAMPM(new Date(pendingOrder.orderDateTime))}
                    </div>

                    <div>
                      <b>Address: </b> {pendingOrder.patientDetails[0].addressLine1}
                    </div>


                    {/* {pendingOrder.isEligibleForSponsoredAHC && (
                      <div className="width-100 text-center text-danger font-size-md">
                        <b>Family AHC Pending</b>
                      </div>
                    )} */}

                    {pendingOrder.orderStatus.currentStatusId==4 ?
                    <div>
                    <Button variant="primary" size="sm" block className="m-t-10 border-curve-5 p-1" 
                    onClick={(e)=>{
                      e.stopPropagation();
                      this.upSellOrder(pendingOrder);

                    }}>
                    Comprehensve Health Management
                    </Button>

                   </div> : null }
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-align-center">No Pending Orders Found</div>
        )}
      </div>
    );
  }

  showCompletedCases() {
    return (
      <div>
        {this.state.completedOrders
          ? Object.keys(this.state.completedOrders).map((elem, index) => {
              const completedOrder = this.state.completedOrders[elem][0];
              let requestIdsString = "";
              this.state.completedOrders[elem].forEach((order, index) => {
                requestIdsString = requestIdsString + order.appointmentId;
                if(index != this.state.completedOrders[elem].length - 1) requestIdsString = requestIdsString + ", ";
              });
              return (
                <div>
                  <div
                    key={index}
                    className="card-box font-size-smd"
                    style={{ boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)" }}
                    onClick={(e) => this.redirectToSample(completedOrder, completedOrder.dependantId, e)}
                  >
                    <div>
                      <b>
                        Order Status:{" "}
                        <span className={`font-color-${completedOrder.orderStatus.currentStatusId}`}>{completedOrder.orderStatus.statusMessage}</span>
                      </b>
                    </div>
                    <div className="p-t-10 width-100">
                      <b>Order ID:</b> {completedOrder.prOrderId}
                    </div>
                    <div className="width-100">
                      <b>Dependant ID:</b> <span>{completedOrder.dependantId ? completedOrder.dependantId : "NA"}</span>
                    </div>
                    <div className="width-100 m-b-10">
                      <b>Request IDs:</b> {requestIdsString}
                    </div>
                    <div className="width-100 position-relative font-size-ml m-b-10">
                      <b>Patient: </b>

                      <span className=" m-r-5">
                        {completedOrder.patientDetails[0].name +
                          " (Age: " +
                          (completedOrder.patientDetails[0].patientAge != null ? completedOrder.patientDetails[0].patientAge : this.getAge(completedOrder.patientDetails[0].patientDOB)) +
                          ", Gender: " +
                          (completedOrder.patientDetails[0].patientGender != null ? completedOrder.patientDetails[0].patientGender : "NA") +
                          ")"}
                      </span>
                      {[4].includes(completedOrder.orderStatus.currentStatusId) && (
                        <button
                          type="button"
                          className="btn btn-default btn-sm m-l-10 patientEdit"
                          onClick={() => this.onEditpatient(completedOrder)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-pencil-square"
                            viewBox="0 0 16 16"
                          >
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path
                              fill-rule="evenodd"
                              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                            />
                          </svg>
                        </button>
                      )}
                    </div>

                    <div>
                      {decrptor(completedOrder.patientDetails[0].aadharNumber) && (
                        <div className="width-100">
                          <b>Aadhaar No:</b> {maskingAdhaar(decrptor(completedOrder.patientDetails[0].aadharNumber))}
                        </div>
                      )}
                      {decrptor(completedOrder.patientDetails[0].passPort) && (
                        <div className="width-100">
                          <b>Passport No / Voter ID:</b> {maskPassportVID(decrptor(completedOrder.patientDetails[0].passPort))}
                        </div>
                      )}
                      {typeof completedOrder.patientDetails[0].priority == "string" && completedOrder.patientDetails[0].priority != "" ? (
                        <div className="width-100">
                          <b>Priority:</b> {completedOrder.patientDetails[0].priority}
                        </div>
                      ) : (
                        ""
                      )}

                      {typeof completedOrder.patientDetails[0].corporateName == "string" && completedOrder.patientDetails[0].corporateName != "" ? (
                        <div className="width-100">
                          <b>Corporate:</b> {completedOrder.patientDetails[0].corporateName}
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="width-100 display-flex">
                        <b>Appointment Time: </b> {this.formatAMPM(new Date(completedOrder.orderDateTime))}
                      </div>

                      <div>
                        <b>Address: </b> {completedOrder.patientDetails[0].addressLine1}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          : <div className="text-align-center">No Completed Orders Found</div>}
      </div>
    );
  }

  getAllOrders() {
    return (
      <div className="order-dashboard">
        <Container>
          <Row>
            <Col md={4}></Col>
            <Col xs={12} md={4}>
              <div className="heading text-align-center font-size-lg bold p-b-10">Your Orders</div>
            </Col>
            <Col md={4}></Col>
          </Row>

          <Row className="p-t-15 font-size-md p-b-10">
            <Col md={3}></Col>
            <Col xs={6} md={3}>
              <div className="order-status-card-btn text-align-center" onClick={() => this.renderRedirect("pending")}>
                <div className={`p-10 ${this.state.activeTab == "pending" ? "active" : "non-active"}`}>
                  <div>{this.state.pendingCaseCount}</div>
                  Pending
                </div>
              </div>
            </Col>
            <Col xs={6} md={3}>
              <div className="order-status-card-btn text-align-center" onClick={() => this.renderRedirect("completed")}>
                <div className={`p-10 ${this.state.activeTab == "completed" ? "active" : "non-active"}`}>
                  <div>{this.state.completedCaseCount}</div>
                  Completed
                </div>
              </div>
            </Col>
            <Col md={3}></Col>
          </Row>

          <Row>
            <Col md={4}></Col>
            <Col xs={12} md={4}>
              <div className="heading text-align-center font-size-md p-t-10 p-t-10 uppercase">
                {this.state.activeTab == "completed" ? "Completed Cases" : ""}
              </div>
              {this.state.activeTab == "pending" ? (
                <div className="p-b-5 deep-pink-color text-align-center font-size-ml bold">
                  {this.state.todayTomorrowMsg}
                  <br />
                  <span className="p-b-5 deep-pink-color text-align-center font-size-smd">{this.state.todaySubMsg}</span>
                </div>
              ) : (
                ""
              )}
            </Col>
            <Col md={4}></Col>
          </Row>
          {this.state.activeTab == "pending" && (
            <Form onSubmit={(e) => this.fetchOrder()}>
              <Form.Group className="mb-3" controlId="OrderId">
                <Form.Label>Order ID to Search:</Form.Label>
                <Form.Control type="text" placeholder="Enter order ID" onChange={(e) => this.handleOrderId(e)} value={this.state.orderId || ""} />
              </Form.Group>

              <Row>
                <Col xs={6} md={6}>
                  <Button variant="primary" type="submit" disabled={!this.state.orderId} className="text-align-center w-100">
                    Search
                  </Button>
                </Col>
                <Col xs={6} md={6}>
                  <Button
                    variant="primary"
                    className="text-align-center w-100"
                    disabled={!this.state.searched}
                    onClick={() =>
                      this.setState({
                        searched: false,
                        orderId: "",
                      })
                    }
                  >
                    Remove
                  </Button>
                </Col>
              </Row>
              <hr />
            </Form>
          )}
          <div className="card-list">{this.state.activeTab == "pending" ? this.showPendingCases() : this.showCompletedCases()}</div>
        </Container>

        <Container>
          <Row>
            {this.state.activeTab == "pending" && this.state.isAnyOrderInSampleTakenState ? (
              <div className="fixed-bottom p-l-15 p-r-15 p-t-5 p-b-5">
                <Button
                  variant="primary"
                  size="lg"
                  block
                  className="border-curve-10"
                  onClick={() => this.routeToLab(this.props.match.params.orderId)}
                >
                  Drop Samples at Lab
                </Button>
              </div>
            ) : (
              ""
            )}
          </Row>
        </Container>

        {this.state.openOrderCreationPopup && (
          <UserLoginDialog 
             userName={this.state.upSellUserName}
            getControl={(status) => this.setState({ openOrderCreationPopup: status })}
            errorAlert={(err) => err && alert(err)}
          />
        )}
        
      </div>
    );
  }

  render() {
    return (
      <div>
        <Backdrop open={this.state.isLoading} sx={{ zIndex: 99999 }}>
          <CircularProgress />
        </Backdrop>
        <CarouselContainer pageId="phlebo_home_page" onDataLoaded={this.handleDataLoaded} dataLoaded={this.state.dataLoadingCompletion}/> 
        <div className={`${this.state.dataLoadingCompletion ? 'carousel-fluid' : ''} `} >
        {this.state.showSnack ? <div className="snackbar show">{this.state.messageSnack}</div> : ""}
        <div>
          {this.getAllOrders()}
        </div>
        {this.state.activeTab=="pending"
        ?
            <Button variant="primary" size="lg" block className="m-t-35 border-curve-10" onClick={() => {
              
              this.setState({openOrderCreationPopup: true, upSellUserName:""});

            }
              }>
              Create New Order
            </Button>
          : null
          }
          <Button
						type="submit"
            block
						size="lg"
            className="m-t-35 border-curve-10"
						style={{
							backgroundColor: "#FFD20A",
							color: "black",
						}}
						onClick={() => {
              this.setState({isLoading: true});
              const getPhleboDeails = JSON.parse(localStorage.getItem("user_details"));
              window.location.href = `https://healthverse.medibuddy.in/smartcare?phleboid=${getPhleboDeails.phleboId}`
            }}
					>
						Earn More &#8377;
					</Button>
        </div>
      </div>
    );
  }
}
export default DependantOrderDashboard;
